import { Box, Flex, Spinner } from '@chakra-ui/react';
import React from 'react';

import delay from 'lib/delay';
import { Button } from 'toolkit/chakra/button';
import { IconButton } from 'toolkit/chakra/icon-button';
import AddressEntity from 'ui/shared/entities/address/AddressEntity';
import IconSvg from 'ui/shared/IconSvg';

import UserWalletAutoConnectAlert from '../UserWalletAutoConnectAlert';
import UserWalletBalance from './UserWalletBalance';
import UserWalletTokenBalances from './UserWalletTokenBalances';

interface Props {
  address: string;
  domain?: string;
  isAutoConnectDisabled?: boolean;
  isReconnecting?: boolean;
  onDisconnect: () => void;
  onOpenWallet: () => void;
}

const UserWalletMenuContent = ({ isAutoConnectDisabled, address, domain, isReconnecting, onDisconnect, onOpenWallet }: Props) => {

  const handleOpenWalletClick = React.useCallback(async() => {
    await delay(100);
    onOpenWallet();
  }, [ onOpenWallet ]);

  return (
    <Box>
      { isAutoConnectDisabled && <UserWalletAutoConnectAlert/> }
      <Flex alignItems="center" columnGap={ 2 } justifyContent="space-between" mb={ 2 }>
        <AddressEntity
          address={{ hash: address, ens_domain_name: domain }}
          truncation="dynamic"
          fontSize="sm"
          fontWeight={ 700 }
        />
        { isReconnecting ? <Spinner size="sm" m="2px" flexShrink={ 0 }/> : (
          <IconButton
            aria-label="Open wallet"
            variant="icon_secondary"
            size="2xs"
            onClick={ handleOpenWalletClick }
          >
            <IconSvg name="gear_slim"/>
          </IconButton>
        ) }
      </Flex>
      <UserWalletBalance address={ address }/>
      <UserWalletTokenBalances address={ address }/>
      <Box h="1px" bg="whiteAlpha.200" my={ 3 }/>
      <Button
        size="sm"
        width="full"
        variant="outline"
        color="white"
        borderColor="whiteAlpha.400"
        _hover={{ bg: 'whiteAlpha.100' }}
        onClick={ onDisconnect }
      >
        Disconnect
      </Button>
    </Box>
  );
};

export default React.memo(UserWalletMenuContent);
